import { MonoMark } from '@/components/primitives/MonoMark'
import { PigmentTick } from '@/components/primitives/PigmentTick'
import { Button } from '@/components/ui/button'
import type { DbLockState } from '../../db/lock'
import { getDb } from '../db'

interface TabLainProps {
  state: DbLockState
}

/**
 * Another tab holds the device database (or this tab handed it over). Shown in place of
 * the shell; "Ambil alih" asks the holder to pause its worker and moves the database here.
 */
export function TabLain({ state }: TabLainProps) {
  const meminta = state.status === 'meminta'
  return (
    <main
      id="isi"
      className="mx-auto flex min-h-dvh w-full max-w-[44rem] flex-col justify-center gap-6 px-4 py-10"
    >
      <MonoMark className="size-16 text-text" />
      <div className="flex flex-col gap-2">
        <h1 className="flex items-baseline gap-1 font-display text-title">
          <PigmentTick />
          SATU sudah terbuka di tab lain
        </h1>
        <p className="measure font-prose text-prose">
          Tutup tab ini dan lanjutkan di tab yang sudah terbuka, atau ambil alih di sini.
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button
          onClick={() => {
            void getDb().requestHandover()
          }}
          disabled={meminta}
        >
          Ambil alih
        </Button>
        <Button variant="outline" onClick={() => window.close()}>
          Tutup
        </Button>
      </div>
    </main>
  )
}
